import React, {useEffect} from 'react'
import css from '../LoginV2Layout.module.scss'
import LoginV2Layout from '../LoginV2Layout'
import {useLoading, useCurrentUser, Home02, Bell04Icon, Gear, colors} from 'usg-lib'
import {useTrackedHotkeys} from "usg-lib/src/index.js";

const AppPicker = ({logo}) => {
  const {currentUser} = useCurrentUser()
  const {showLoading} = useLoading()

  // Already url-encoded as "redirectTo=..." by SsoUI, same value App.jsx reads.
  const pendingRedirectTo = usg.data.redirectTo ?? null // eslint-disable-line

  const redirectTo = (audience) => {
    showLoading()
    let uri = '/sso/redirect?audience='+audience
    if (pendingRedirectTo) {
      uri += '&'+pendingRedirectTo
    }
    window.location.href = uri
  }

  useEffect(() => {
    if (!currentUser) {
      return;
    }

    if (currentUser.allowedInternalSsoTokenAudience && currentUser.allowedInternalSsoTokenAudience.length === 2) {
      redirectTo(currentUser.allowedInternalSsoTokenAudience[1])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser])

  let hasAccessToExtranet = false, hasAccessToGustave = false, hasAccessToHq = false
  for (let i in currentUser?.allowedInternalSsoTokenAudience) {
    let audience = currentUser.allowedInternalSsoTokenAudience[i]
    switch (audience) {
      case 'EXTRANET':
        hasAccessToExtranet = true
        break;
      case 'GUSTAVE':
        hasAccessToGustave = true
        break;
      case 'HQ':
        hasAccessToHq = true
        break;
      default:
        break;
    }
  }

  useTrackedHotkeys('g>p',
    () => {
      if (!hasAccessToExtranet) {
        return false;
      }
      redirectTo('EXTRANET')
    },
    'extranet'
  )
  useTrackedHotkeys('g>o',
    () => {
      if (!hasAccessToGustave) {
        return false;
      }
      redirectTo('GUSTAVE')
    },
    'onarrival'
  )
  useTrackedHotkeys('g>h',
    () => {
      if (!hasAccessToHq) {
        return false;
      }
      redirectTo('HQ')
    },
    'hq'
  )

  if (!currentUser) {
    return null;
  }

  return (
    <LoginV2Layout logo={logo}>
      <div className={css.contentWrapper}>
        <div className={css.welcomeSection}>
          <h1 className={css.welcomeTitle}>Welcome back!</h1>
          <p className={css.welcomeSubtitle}>Pick an application to access</p>
        </div>
        <div className={css.appsSelector}>
          {hasAccessToExtranet &&
            <div className={css.appButtonWrapper} onClick={() => redirectTo('EXTRANET')}>
              <div className={css.appButton}>
                <div className={css.iconCircle}>
                  <Home02 width={22} height={22} color={colors.secondaryColor}/>
                </div>
                <h2 className={css.appName}>Platform</h2>
              </div>
            </div>
          }
          {hasAccessToGustave &&
            <div className={css.appButtonWrapper} onClick={() => redirectTo('GUSTAVE')}>
              <div className={css.appButton}>
                <div className={css.iconCircle}>
                  <Bell04Icon width={24} height={24} color={colors.secondaryColor}/>
                </div>
                <h2 className={css.appName}>On-Arrival</h2>
              </div>
            </div>
          }
          {hasAccessToHq &&
            <div className={css.appButtonWrapper} onClick={() => redirectTo('HQ')}>
              <div className={css.appButton}>
                <div className={css.iconCircle}>
                  <Gear width={24} height={24} color={colors.secondaryColor}/>
                </div>
                <h2 className={css.appName}>HQ</h2>
              </div>
            </div>
          }
        </div>
      </div>
    </LoginV2Layout>
  )
}

export default AppPicker
